import Vue from 'vue'
import App from './App.vue';
import vuetify from './plugins/vuetify';
import store from './store';

import router from './router'
import Toasted from 'vue-toasted';
import VueMq from 'vue-mq';
import VModal from 'vue-js-modal';
import globalMixin from "./globalMixin";
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 450,
    md: 1250,
    lg: Infinity,
  },
  defaultBreakpoint: 'sm' // customize this for SSR
})

Vue.config.productionTip = false;

Vue.use(Toasted, {
  theme: 'outline',
  duration: 6500,
});

Vue.prototype.$swal = Swal;

Vue.mixin(globalMixin)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
